import { render } from "./ImageSpinner.vue?vue&type=template&id=11a16c4a&scoped=true"
const script = {}

import "./ImageSpinner.vue?vue&type=style&index=0&id=11a16c4a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\webencusco\\projects\\fronted-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a16c4a"]])

export default __exports__